<script>
    // Importa el componente Cliente
    import ClienteView from "../../viewsERP/Cliente.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <ClienteView />
  </div>
</div>